import { create } from "zustand";
import { TUser } from "./types";
import userApi from "@/api/user";
import authService from "../auth/services";
import { api } from "@/api";

export const userState = create<TUser | null>(() => null);

const profileService = {
  getUser: async (cache = false): Promise<TUser | null> => {
    try {
      if (!authService.isLoggedIn()) return null;
      if (userState.getState() !== null && !cache) return userState.getState();
      const { data } = await userApi.me();
      if (data.data.success) {
        authService.setLoggedIn();
      }
      userState.setState(data.data.user);
      return data.data.user;
    } catch (error) {
      authService.removeIsLoggedIn();
      return null;
    }
  },

  updateDownlinerPaymentSlip: async (data: {}) => {
    await api.post("members/update-downliner-payment-slip", data);
  },
};

export default profileService;
